import React, { useRef } from 'react';
import ReactECharts from 'echarts-for-react';

const DistributionChart = ({ data }) => {
    const ref = useRef(null);

    const options = {
        tooltip: {
            trigger: 'item',
            formatter: params => `${params.marker}${params.name}: <b>${new Intl.NumberFormat('en-GB', { maximumFractionDigits: 0 }).format(params.value)}</b>`
        },
        legend: {
            bottom: 0,
            left: 'center',
            orient: 'vertical'
        },
        series: [
            {
                top: '-40%',
                name: 'Distribution',
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
                labelLine: {
                    show: false
                },
                data,
                color: data.map(e => e.colour)
            }
        ]
    };

    return (
        <ReactECharts
            option={options}
            style={{ width: 250, height: 320 }}
            opts={{ renderer: 'svg' }}
            ref={ref}
        />
    );
};

export default DistributionChart;